module.exports = __webpack_public_path__ + "img/add.3bfb517c.png";